import RegistryList from './registry-list';

export default RegistryList;
